export const CANCEL_DEVICE_MODAL_FORM = 'CANCEL_DEVICE_MODAL_FORM'
